var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing-found"},[_c('div',{staticClass:"nothing-found-wrap"},[_c('NotfoundImage'),_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"paragraph"},[_vm._t("body")],2),(_vm.btnText)?_c('b-button',{on:{"click":function($event){return _vm.btnAction()}}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }